import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';


export interface MxTimezoneService  {
    get(): Observable<string>;
    getTimezone(): string;
    getOffset(): string;
}
export const MX_TIMEZONE_TOKEN = new InjectionToken<MxTimezoneService>('MX_TIMEZONE_TOKEN');
